// Import model
import { DataviewContactTaskResponse } from '../models/DataviewContactTaskResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ContactTask } from '../models/ContactTask';
import { DataView } from '../models/DataView';
import { FilterContactTaskRequest } from '../models/FilterContactTaskRequest';

// Import dependency serializers (for complex types)
import { ContactTaskSerializer } from './ContactTaskSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterContactTaskRequestSerializer } from './FilterContactTaskRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewContactTaskResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewContactTaskResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewContactTaskResponse instance
   */
  static deserialize(json: string): DataviewContactTaskResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewContactTaskResponse instance
   */
  static fromObject(obj: any): DataviewContactTaskResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewContactTaskResponse');
    }


    const instance: DataviewContactTaskResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        ContactTaskSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterContactTaskRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewContactTaskResponse instances
   */
  static deserializeArray(json: string): DataviewContactTaskResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewContactTaskResponse instance to a JSON string
   */
  static serialize(instance: DataviewContactTaskResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewContactTaskResponse instance to a plain object
   */
  static toObject(instance: DataviewContactTaskResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        ContactTaskSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterContactTaskRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewContactTaskResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewContactTaskResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
